import React, { useContext, useEffect, useRef, useState } from 'react'
import { Field, Form, Formik } from 'formik';
import "react-range-slider-input/dist/style.css";
import Slider from "react-slick";
import { VehicleContext } from '../Components/Context/VehicleContext';
import { getImages } from '../Components/Common/const';
import MyVehicleForm from '../Components/SellYourCar/MyVehicleForm';
import ModalLayout from '../Components/Common/ModalLayout';
import GetQuoteModal from '../Components/SellYourCar/GetQuoteModal';
import SeoMeta from '../Components/Common/SeoMeta';
import { Helmet } from 'react-helmet';

const reviewsList = [
  {
    name: "Joshua Tanton",
    content:
      "I found a vehicle in amazing condition that I have been looking for, for a while. Finally found it. I gave Bobby a call. I informed I was interested and would be there the next day. I showed up saw the car and the pictures did not do this car justice whatsoever. It was in the exact condition, possibly better than advertised. He offered a test drive with zero hesitation. Price was amazingly fair for the condition, year and mileage. If I’m ever in the need for another luxury vehicle I will 100 percent be going back to Bobby! I will recommend anyone that I know to Bobby for all the fairness and transparency and great customer service that he and his wife provided! Thank you Bobby for my amazing ZO6!",
  },
  {
    name: "Rudy Rodriguez (MedPlan)",
    content:
      "Bought a 2022 F450 from Bobby, the car was perfect! Low miles and at a great price. Called him on a Sunday and by 1pm Monday I was picking up my truck. Tag was ready very easy transaction",
  },
  {
    name: "Aaron Taylor",
    content:
      "We recently purchased a used Audi TTS from Bobby, and I can confidently say it was the most seamless car-buying experience I’ve ever had. From start to finish, Bobby was incredibly patient, helpful, and professional. He walked us through the financing process, answered every question thoroughly, and was super responsive—even after hours. It’s clear he genuinely cares about his customers and goes the extra mile to make the process smooth and stress-free. I highly recommend Bobby to anyone in the market for a vehicle, and I’ll absolutely be returning to him for future purchases.",
  },
  {
    name: "Chris Ciocca",
    content:
      "After doing business with Mercedes Showroom a few times now, they are always my first stop. The quality of their handpicked vehicles are top of the line. Always well maintained, great options, and the best customer service. I am a true customer for life.",
  },
  {
    name: "Jose Pretel",
    content:
      "Huge thank you to Bobby at Mercedeshowroom for making my Hellcat purchase smooth and stress-free. From the start, he was honest, knowledgeable, and didn’t try to play any of the usual dealership games. He made sure I got exactly what I wanted and was super easy to work with the whole way through.",
  },
  {
    name: "Ray Vitiello",
    content:
      "We were out of the country when the exact car I was looking for popped up on Carfax. I contacted Kendall and sent a deposit, and they held the car for me. When I went to see it, it was exactly as described, in like-new condition. Bobby made the whole transaction easy. If you’re looking for an alternative to a huge Mercedes dealership, this mom & pop operation is a great choice. Highly recommended.",
  },
  {
    name: "Gianluca Esposito",
    content:
      "I recently had a fantastic experience at the Mercedes showroom. Bobby was exceptionally nice, always available, and very understanding throughout the entire process. He provided me with great service and made sure everything went smoothly. I got a wonderful price and am thoroughly enjoying my beautiful SL 450. I definitely recommend this showroom for their professional staff and high-quality vehicles. Great people and top-notch service!",
  },
  {
    name: "Sasha Crisp",
    content:
      "Great experience picking up our 2014 Ferrari California. The condition was better than expected and Bobby went out of his way to get us the second key and owner’s manuals that were missing. Plus, no hassle or pressure when we were working through the deal. Plus, the way they handle the paperwork was really impressive. It’s always risky buying from an independent dealer but I have no reservations highly recommending Mercedes Showroom. Their business model is the best.",
  },
];
  
const SellYourCar = () => {
     const {getVehicleData, priceFormatter, filteredVehicleData } = useContext(VehicleContext);
    var srpCarSlider = {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        centerPadding: '120px',
        arrows: true,
        dots: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };

    const sliderRef = useRef(null);
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    
    const [selectedValue, setSelectedValue] = useState("");
    const [getQuoteModal, setGetQuoteModal] = useState(false);
    const closeGetQuoteModal = () => {
        setGetQuoteModal(false)
    }
    const [openDragDropModal, setopenDragDropModal] = useState(false);
    const [previewURL, setPreviewURL] = useState(null);
    // console.log("openDragDropModal", openDragDropModal)
    // console.log("previewURL", previewURL)
    const closeDragDropModal = () => {
        setopenDragDropModal(false)
    }
    const [files, setFiles] = useState([]);

    useEffect(() => {
        console.log("home page useEffect");
        getVehicleData();

    }, []);
  return (
    <>
            <Helmet>
                <title>Sell or Trade Your Mercedes-Benz | Pompano Beach, FL</title>
                <meta name="description" content="Sell or trade in your used car quickly. We buy Mercedes-Benz and other luxury vehicles – fast appraisal and payment." />
                <meta name="keywords" content="" />
                <meta property="og:title" content="Sell or Trade Your Mercedes-Benz | Pompano Beach, FL" />
                <meta property="og:description" content="Sell or trade in your used car quickly. We buy Mercedes-Benz and other luxury vehicles – fast appraisal and payment." />
            </Helmet>
            <section className='common-wrap d-flex align-items-center' style={{ backgroundImage: `url(${getImages('sell-your-car-hero-bg.webp')})` }}>
                <div className='w-100'>
                    <div className='container'>
                        <h1 className='xl-title text-uppercase text-center wow reveal fadeInUp' >Sell or Trade</h1>
                        <h2 className='lg-title text-uppercase text-center fw-500 mt-3 mb-3 wow reveal fadeInUp' >We Pay top dollar for your vehicle</h2>
                    </div>
                </div>
            </section>
            <section className='hassle-process-wrap'>
                <div className='container'>
                    <div className='hassle-process-box d-flex wow reveal fadeIn' >
                        <div className='hpb-left w-50'>
                            <div className='hpb-xs-title text-uppercase mb-2 wow reveal fadeInUp' >Call</div>
                            <div className='text-center'>
                                <a href='tel:9549463000' className='md-title call-text-title font-2-5em wow reveal fadeInUp' >954-946-3000</a>
                            </div>
                            <div className='md-title text-center fw-400 text-uppercase my-5 wow reveal fadeInUp' >How Our Process Works</div>
                            <div className='hpb-process-list'>
                                <div className='d-flex align-items-center wow reveal fadeInUp' >
                                    <div className='hpb-circle me-3'>1</div>
                                    <div className='xs-title font-1-1em fw-400 text-uppercase'>Send in your vehicle information</div>
                                </div>
                                <div className='d-flex align-items-center wow reveal fadeInUp'>                                     
                                    <div className='hpb-circle me-3'>2</div>
                                    <div className='xs-title font-1-1em fw-400 text-uppercase'>Quickly receive an estimate</div>
                                </div>
                                <div className='d-flex align-items-center wow reveal fadeInUp' >
                                    <div className='hpb-circle me-3'>3</div>
                                    <div className='xs-title font-1-1em fw-400 text-uppercase'>Finalize with our friendly agents</div>
                                </div>
                            </div>
                        </div>
                        <div className='hpb-right w-50'>
                            <h3 className='lg-title text-uppercase text-center wow reveal fadeInUp' >NO HASSLE <br />PROCESS</h3>
                            
                            <MyVehicleForm 
                                setSelectedValue={setSelectedValue}
                                getQuoteModal={getQuoteModal}
                                setGetQuoteModal={setGetQuoteModal}
                            />
                            <div className='sm-title text-center mt-90 fw-500 text-white wow reveal fadeInUp' >Simple, Fast & Free</div>
                            <div className='text-center pt-3 wow reveal fadeInUp'>                                 
                                <span className='px-5 d-inline-block hpb-border-t pt-3'>
                                    <img src={getImages('tg-logo-bw.png')} />
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='deals-wrap'>
                <div className='hpb-xs-title text-uppercase mb-2 wow reveal fadeInUp' >TRADE UP FOR THE</div>
                <h3 className='md-title text-center font-2-5em mb-5 wow reveal fadeInUp' >HOTTEST DEALS</h3>
                <div className='deals-block wow reveal fadeIn' >
                                {/* {console.log("filteredVehicleData", filteredVehicleData)} */}
                        {filteredVehicleData && (
                            <Slider className='deals-slider' {...srpCarSlider}>
                                {filteredVehicleData.filter((item) => item.inventory_manage.featured).map((item, index) => (
                                    <div key={index} className='deal-col'>
                                        <div className='inner'>
                                            <article className="cs-card cs-card--2 fv-box">
                                                <div className="cs-card__img fv-top"
                                                    style={{
                                                        backgroundImage: `url(${item.images[0]})`,
                                                    }}
                                                ></div>
                                                <a href={"/vdp?vin=" + item.vin} target='_blank' className="cs-card_link">
                                                    <div className="cs-card__img--hover fv-top"
                                                        style={{
                                                            backgroundImage: `url(${item.images[0]})`,
                                                        }}></div>
                                                </a>
                                                <div className="fv-bottom">
                                                    <div className="sm-title text-white fw-300 deal-main-title">{item.year} {item.make} {item.model}</div>
                                                    <div className="d-flex align-items-end justify-content-between mt-1">
                                                        <div className="fv-price fw-500">{priceFormatter(item.price, true)}</div>
                                                        <div className="fv-mileage opacity-0-7 font-1em">{item.mileage.toLocaleString()}mi</div>
                                                    </div>
                                                    <div className='mt-3'>
                                                        <a href={"/vdp?vin=" + item.vin} target='_blank' className='vehicle-dtl-btn text-gray font-1em w-100 d-inline-block text-uppercase px-3 py-2'>Check Availability</a>
                                                    </div>
                                                </div>
                                            </article>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        )}
                    {/* <Slider className='deals-slider' {...srpCarSlider} >
                        {carData.map((car, index) =>
                            <div key={index} className='deal-col'>
                                <div className='inner'>
                                    <article className="cs-card cs-card--2 fv-box">
                                        <div className="cs-card__img fv-top"
                                            style={{
                                                backgroundImage: `url(${getImages(car.image)})`,
                                            }}
                                        ></div>
                                        <a href={`/vehicle-details/${car.vdp_url ?? `used-${car.vin}`}`} target='_blank' className="cs-card_link">
                                            <div className="cs-card__img--hover fv-top"
                                                style={{
                                                    backgroundImage: `url(${getImages(car.image)})`,
                                                }}></div>
                                        </a>
                                        <div className="fv-bottom">
                                            <div className="sm-title text-white font-bold deal-main-title">{car.vehicle_name}</div>
                                            <div className="d-flex align-items-end justify-content-between mt-1">
                                                <div className="sm-title">{numberFormatter(car.price, true)}</div>
                                                <div className="sm-title opacity-0-7 font-1em">{numberFormatter(car.mileage)}</div>
                                            </div>
                                            <div className='mt-3'>
                                                <a href={`/vehicle-details/${car.vdp_url ?? `used-${car.vin}`}`} target='_blank' className='btn-theme text-gray w-100 d-inline-block'>Check Availability</a>
                                            </div>
                                        </div>
                                    </article>
                                </div>
                            </div>
                        )}
                    </Slider> */}
                </div>
            </section>
            <section className='sell-or-trade-wrap wow reveal fadeInUp' >
                <div className='container'>
                    <div className='d-flex align-items-center justify-content-between sot-flex'>
                        <div>
                            <div className='mb-2'>
                                <img src={getImages('tg-logo-bw.png')} />
                            </div>
                            <h4 className='md-title text-start font-2-2em'>Sell or Trade your Vehicle</h4>
                        </div>
                        <div className='sot-right'>
                            <MyVehicleForm 
                                setSelectedValue={setSelectedValue}
                                getQuoteModal={getQuoteModal}
                                setGetQuoteModal={setGetQuoteModal}
                                sotForm={true}
                            />
                        </div>
                    </div>
                </div>
            </section>
            <section className='reviews-wrap'>
                <div className='container'>
                    <div className='hpb-xs-title text-uppercase mb-2 wow reveal fadeInUp' >Recent</div>
                    <h4 className='md-title text-center font-2-5em text-uppercase mb-5 wow reveal fadeInUp' >Google Reviews</h4>
                    <div className=' wow reveal fadeIn' >
                        
            <Slider ref={sliderRef} {...settings} className='review-slider'>
              {reviewsList.map((review, index) => (
                <div className="review-item" key={index}>
                  <div className="review-box">
                    <div className="review-mnh">
                      <p className="clamp-4">
                        {review.content}
                      </p>
                    </div>
                    <div className="d-flex align-items-end justify-content-between mt-1">
                      <div>
                        <div className="mb-md-3 mb-2 d-flex align-items-center">
                          {[...Array(5)].map((_, i) => (
                            <img key={i} className="me-1" src={getImages("star.svg")} alt="star" />
                          ))}
                        </div>
                        <div className="reviewer-name">{review.name}</div>
                      </div>
                      <div>
                        <div className="quote-icon mb-2">
                          <img src={getImages("quote-shape.png")} alt="quote" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}

            </Slider>
                    </div>
                </div>
            </section>
            
            {/* <section className='demand-vehicle-wrap'>
                <div className='container'>
                    <div className='hpb-xs-title text-uppercase mb-2 wow reveal fadeInUp' >WHAT ARE THE</div>
                    <div className='md-title text-center font-2-5em text-uppercase mb-0 wow reveal fadeInUp' >Most in Demand Vehicles?</div>
                    <div className='row demand-vehicle-block'>
                        <div className='col-lg-3 col-12'>
                            <div className='demand-vehicle-box'>
                                <img src={getImages('ferrari-488.png')}/>
                                <div className='md-title text-white font-1-2em mb-1'>Ferrari 488</div>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                            </div>
                        </div>
                        <div className='col-lg-3 col-12'>
                            <div className='demand-vehicle-box'>
                                <img src={getImages('mercedes-g-63.png')}/>
                                <div className='md-title text-white font-1-2em mb-1'>Mercedes G63</div>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                            </div>
                        </div>
                        <div className='col-lg-3 col-12'>
                            <div className='demand-vehicle-box'>
                                <img src={getImages('porsche-911.png')}/>
                                <div className='md-title text-white font-1-2em mb-1'>Porsche 911</div>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                            </div>
                        </div>
                        <div className='col-lg-3 col-12'>
                            <div className='demand-vehicle-box'>
                                <img src={getImages('corvertte.png')}/>
                                <div className='md-title text-white font-1-2em mb-1'>Chevy Corvette</div>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section> */}
            <section className='trading-wrap'>
                <div className='container'>
                    <h5 className='md-title text-center font-2-5em fw-500 text-uppercase mb-md-5 mb-4 wow reveal fadeInUp' >Tips on Trading or Selling Your Vehicle</h5>
                    <div className='wow reveal fadeInUp' >
                        <p>To find the right buyer for your used car, starting with a professional vehicle appraisal is a smart move. While several exotic car buyers operate in the market, partnering with a reputable company is key. Established dealerships in the United States adhere to specific standards and regulations, offering a level of assurance that individual buyers may not provide.</p>

                        <p>We specialize in purchasing exotic vehicles, drawing upon our team's extensive experience in the high-end automotive market. When selecting a used car buyer, prioritize expertise and a proven track record. Following your car appraisal, you can efficiently move forward to receive a cash offer or explore trade-in options for your vehicle.</p>
                    </div>
                </div>
            </section>
            <ModalLayout open={getQuoteModal} close={closeGetQuoteModal} darkThemeCls='true' modalWidth={750}>
                <GetQuoteModal 
                    selectedValue={selectedValue}
                    close={closeGetQuoteModal}
                    setopenDragDropModal={setopenDragDropModal}
                    setPreviewURL={setPreviewURL}
                    files={files}
                    setFiles={setFiles}
                />
            </ModalLayout>
    </>
  )
}

export default SellYourCar